module.exports = __webpack_public_path__ + "img/7_50.1333c2d0.png";